module.exports = __webpack_public_path__ + "static/img/Frame 4108@2x(6).a736778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame 4108@2x(6).png
// module id = Nb9U
// module chunks = 59